import { Component, OnInit } from '@angular/core';
import { DialogService } from "primeng/dynamicdialog";
import { MenuItem, MessageService } from "primeng/api";
import { EmployeeModel } from "../../models/employees/employee.model";
import { AddOrEditEmployeeComponent } from "./add-or-edit-employee/add-or-edit-employee.component";
import { EmployeeRoleEnum } from "../../enums/employee-role.enum";
import { AssignVenuesComponent } from "./assign-venues/assign-venues.component";
import { DeleteEmployeeComponent } from "./delete-employee/delete-employee.component";
import { TranslateService } from "@ngx-translate/core";
import { EmployeeService } from "../../services/employees/employe.service";
import { Subject, takeUntil } from "rxjs";
import { ActivatedRoute } from '@angular/router';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.scss']
})
export class EmployeesComponent implements OnInit {

  //#region Fields
  public listAllEmployees: Array<EmployeeModel> = new Array<EmployeeModel>();
  public employeeModel: EmployeeModel;
  public imagePath: string = './assets/images/logo/profile-picture-placeholder.png'
  public items: { [name: string]: MenuItem[] } = {};
  public EmployeeRoleEnum = EmployeeRoleEnum;
  public spinner: boolean;
  public unsubscribe: Subject<void> = new Subject<void>();
  //#endregion

  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public employeeService: EmployeeService,
    private messageService: MessageService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    public currentVenueHelper: CurrentVenueHelperService,
  ) {
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe(() => {
      this.addFunctionToAllEmployees();
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      }
    }); 
    this.getEmployees();
  }

  //#endregion

  //#region Public Methods
  addEmployee() {
    const ref = this.dialogService.open(AddOrEditEmployeeComponent, {
      header: this.translate.instant('EMPLOYEES.ADD_EMPLOYEE'),
      styleClass: 'dialog_long , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.getEmployees();
        this.messageService.add({ severity: 'success', summary: this.translate.instant("EMPLOYEES.EMPLOYEE_ADDED"), life: 3000 });
      }
    });
  }

  editEmployee(employeeId: string) {
    const ref = this.dialogService.open(AddOrEditEmployeeComponent, {
      data: {
        employeeId: employeeId
      },
      header: this.translate.instant('EMPLOYEES.EDIT_EMPLOYEE'),
      styleClass: 'dialog_long , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.getEmployees();
        this.messageService.add({ severity: 'success', summary: this.translate.instant("EMPLOYEES.EMPLOYEE_EDITED"), life: 3000 });
      }
    });
  }

  deleteEmployee(employeeId: string) {
    const ref = this.dialogService.open(DeleteEmployeeComponent, {
      data: {
        id: employeeId
      },
      header: this.translate.instant('EMPLOYEES.DELETE_EMPLOYEE'),
      styleClass: 'dialog_long , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.getEmployees();
        this.messageService.add({ severity: 'success', summary: this.translate.instant("EMPLOYEES.EMPLOYEE_DELETED"), life: 3000 });
      }
    });
  }

  assignVenues(employeeId: string) {
    const ref = this.dialogService.open(AssignVenuesComponent, {
      data: {
        id: employeeId
      },
      header: this.translate.instant('EMPLOYEES.ASSIGN_VENUES').toUpperCase(),
      width: '275px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.getEmployees();
        this.messageService.add({ severity: 'success', summary: this.translate.instant("EMPLOYEES.EMPLOYEE_ASSIGNED_TO_VENUE"), life: 3000 });
      }
    });
  }

  getEmployees() {
    this.listAllEmployees = new Array<EmployeeModel>();
    this.spinner = true;
    this.employeeService.listAllEmployees()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.listAllEmployees = response;
          this.addFunctionToAllEmployees();
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });

  }

  addFunctionToAllEmployees(): void {
    this.listAllEmployees.forEach(employee => {
      this.items[employee.id] = [{
        label: this.translate.instant('EDIT'),
        command: () => {
          this.editEmployee(employee.id);
        }
      },
      {
        label: this.translate.instant('EMPLOYEES.ASSIGN_VENUES'),
        command: () => {
          this.assignVenues(employee.id);
        }
      },
      {
        label: this.translate.instant('DELETE'),
        command: () => {
          this.deleteEmployee(employee.id);
        }
      }];
    });
  }

  determineImageForEmployee(pictureUrl: string) {
    const image = pictureUrl ? pictureUrl : this.imagePath;
    return encodeURI(image);
  }
  //#endregion
}
